module.exports = __webpack_public_path__ + "img/IMG_058-thumb-510x363-1106_2023.ccb05062.png";